export default {
    COLORS: {
      CYAN: '#43A7A6',

      
      YELLOW: '#FFBE03',
      LIGHTBLUE1: '#008DFF',
      LIGHTBLUE2: '#40A0D4',
      BLUE: '#256EA2',  
      GREY: '#EBF4F7',
      DARKGREY: '#3d3d3e',
      WHITE: '#FFFFFF',

      BACKGROUND_BLUE: 'linear-gradient(to right, #008DFF, #40A0D4)'
    }
  }